import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RebateDocumentView, THIRD_PARTY_NAME } from './rebate-document-view';
import { useRebateDocumentData } from './use-rebate-document-data';

/**
 * Route-connected entry point: /rebate-incentive-print?bankId=<id>&commodityType=Local|International
 * Renders the "Marketing Incentive" letter: Al Shmokh pays the bank / third party / both,
 * depending on the bank's saved rebate letter category.
 */
export const RebateIncentivePrint = (props: RouteComponentProps) => {
  const { language, bankName, accountNumber, letterCategory, referenceNo, date, periodLabel, currency, amount } =
    useRebateDocumentData('incentive');

  const beneficiaryName = (() => {
    switch (letterCategory) {
      case 'REBATE_THIRD_PARTY':
        return THIRD_PARTY_NAME[language];
      case 'REBATE_BANK_A_THIRD_PARTY':
        return `${bankName} + ${THIRD_PARTY_NAME[language]}`;
      case 'REBATE_BANK_A':
      default:
        return bankName;
    }
  })();

  return (
    <RebateDocumentView
      language={language}
      docType="incentive"
      referenceNo={referenceNo}
      date={date}
      recipientName={bankName}
      beneficiaryName={beneficiaryName}
      accountNumber={accountNumber}
      amount={amount}
      currency={currency}
      month={periodLabel}
    />
  );
};

export default RebateIncentivePrint;
